import React from 'react';
import { useCookie } from "react-use";
import {FullScreenLoader} from '../share';
import {currentUserApi} from '../apis/CurrentUser.api';

type IAuthMiddleware = {
    children: React.ReactElement;
};

const AuthMiddleware: React.FC<IAuthMiddleware> = ({children}) => {
    const [loggedIn] = useCookie('logged_in');
    const location = window.location;

    const skipLoad =
        location.pathname === '/login' ||
        location.pathname === '/register' ||
        location.pathname === '/forgot-password' ||
        location.pathname === '/reset-password' ||
        location.pathname === '/change-password' ||
        location.pathname === '/401' ||
        location.pathname === '/404' ||
        location.pathname.startsWith('/privacy') ||
        location.pathname.startsWith('/terms')

    const {isLoading} = currentUserApi.endpoints.getMe.useQuery(null, {
        skip: !loggedIn || skipLoad,
    });

    if (isLoading) {
        return <FullScreenLoader/>;
    }

    return children;
};

export default AuthMiddleware;
